import * as signalR from "@microsoft/signalr";
import { store } from "@/store";
import { env } from "@/env";
import { IReceptionStateUpdated, IReception, IOtherAppointment, IReceptionNotification, NotificationType, ReceptionType, ISlot } from "@/models";
import { ToastHelper } from "@/helpers/ToastHelper";

const hubUrl = `${env.api.origin}${env.api.hubPath}/receptions`;
const receptionsHub = new signalR.HubConnectionBuilder()
    .withUrl(hubUrl, { accessTokenFactory: () => store.dispatch("user/getAccessToken") })
    .build();

receptionsHub.on("ReceptionStateUpdated", (reception: IReception) => {
    store.commit("receptions/EDIT_RECEPTION", reception);

    const receptionNotification: IReceptionNotification = {
        askAppointment: null,
        reception,
        type: NotificationType.Appointment,
        startTime: reception.expectedArrival,
    };

    store.commit("receptions/MANAGE_NOTIFICATION", receptionNotification);
});

receptionsHub.on("ReceptionCreated", (receptionCreated: IReception) => {
    store.commit("receptions/ADD_RECEPTION", receptionCreated);
});

receptionsHub.on("ReceptionUpdated", (receptionUpdated: IReception) => {
    store.commit("receptions/EDIT_RECEPTION", receptionUpdated);
});

receptionsHub.on("ReceptionDeleted", (receptionId: number, slotId: number, type: ReceptionType) => {
    store.commit("receptions/DELETE_RECEPTION", { receptionId, slotId, type });

    if (store.state.user.permission.security || store.state.user.permission.reception) {
        ToastHelper.receptions.toastDeleted();
    }
});

receptionsHub.on("AddNotification", (reception: IReception) => {
    const receptionNotification: IReceptionNotification = {
        askAppointment: null,
        reception,
        type: NotificationType.Appointment,
        startTime: reception.expectedArrival,
    };

    store.commit("receptions/MANAGE_NOTIFICATION", receptionNotification);
});

receptionsHub.on("ReceptionSlotsUpdated", (startSlot: ISlot, endSlot: ISlot) => {
    store.commit("receptions/SET_RECEPTION_START_SLOT", startSlot);
    store.commit("receptions/SET_RECEPTION_END_SLOT", endSlot);
});

export { receptionsHub };
